import React from 'react';
import { Link } from 'react-router-dom';
import {
  ArrowRight, Car, Cog, Heart, FlaskConical, Cpu, Shirt,
  ShoppingCart, ShoppingBag, UtensilsCrossed, Wind, HardHat, Fuel
} from 'lucide-react';
import Hero from '../components/Hero';
import './Industries.css';

const Industries = () => {
  const industries = [
    { icon: Car, name: 'Automotive & Auto Components', desc: 'Specialized logistics for automotive parts, components, and finished vehicles with precision handling.' },
    { icon: Cog, name: 'Engineering & Industrial Equipment', desc: 'Reliable transportation of heavy machinery, industrial equipment, and engineering components.' },
    { icon: Heart, name: 'Pharmaceuticals & Healthcare', desc: 'Temperature-controlled and compliant logistics for pharmaceutical and healthcare products.' },
    { icon: FlaskConical, name: 'Chemicals & Specialty Products', desc: 'Safe handling and transportation of chemicals and specialty products with full regulatory compliance.' },
    { icon: Cpu, name: 'Electronics & Technology', desc: 'Secure logistics for high-value electronics, tech components, and sensitive equipment.' },
    { icon: Shirt, name: 'Textiles & Garments', desc: 'Efficient supply chain solutions for textile manufacturers and garment exporters.' },
    { icon: ShoppingCart, name: 'FMCG & Consumer Goods', desc: 'Fast, reliable distribution networks for fast-moving consumer goods and retail products.' },
    { icon: ShoppingBag, name: 'Retail & E-Commerce', desc: 'End-to-end logistics solutions for retail and e-commerce businesses with last-mile delivery.' },
    { icon: UtensilsCrossed, name: 'Food & Beverage', desc: 'Specialized handling for food and beverage products with compliance and quality assurance.' },
    { icon: Wind, name: 'Renewable Energy', desc: 'Project logistics for renewable energy components including wind turbines and solar equipment.' },
    { icon: HardHat, name: 'Project & Heavy Engineering', desc: 'Complex project logistics for heavy engineering, infrastructure, and construction projects.' },
    { icon: Fuel, name: 'Oil & Gas', desc: 'Reliable logistics support for the oil and gas industry including equipment and materials.' },
  ];

  return (
    <div className="industries">
      <Hero
        label="Industries"
        title="Industries We Serve"
        subtitle="Supporting diverse industries with reliable logistics solutions."
        size="medium"
        image="/img/industries-hero.jpg"
      />

      <section className="section industries-intro">
        <div className="container">
          <div className="text-center">
            <span className="section-label">Our Expertise</span>
            <h2 className="section-title">Supporting Diverse Industries with Reliable Logistics Solutions</h2>
            <p className="section-subtitle">
              Denver Logistics Private Limited provides customized logistics and freight forwarding solutions
              across a wide range of industries. Our multimodal capabilities, global network, and experienced
              team enable us to meet the unique transportation and supply-chain requirements of different
              business sectors.
            </p>
          </div>
          <div className="industries__grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-card__icon">
                  <industry.icon size={28} />
                </div>
                <h3 className="industry-card__name">{industry.name}</h3>
                <p className="industry-card__desc">{industry.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section industries-commitment">
        <div className="container">
          <div className="industries-commitment__inner">
            <div className="industries-commitment__content">
              <h2>No Matter the Industry</h2>
              <p>
                We deliver the same commitment to reliability, safety, and customer satisfaction
                — every single time.
              </p>
            </div>
            <Link to="/quote" className="btn btn-white btn-lg">
              Get a Quote <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;
